import { render, staticRenderFns } from "./shu.vue?vue&type=template&id=282aa213&scoped=true&"
import script from "./shu.vue?vue&type=script&lang=js&"
export * from "./shu.vue?vue&type=script&lang=js&"
import style0 from "./shu.vue?vue&type=style&index=0&id=282aa213&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282aa213",
  null
  
)

export default component.exports